import { SIDE_MENU_EVENTS } from '@src/components/menu/sideMenu';

export const CATEGORIES = {
  WORLDS: 'worlds',
  PREFABS: 'prefabs',
} as const;

export type CategoryType = typeof CATEGORIES[keyof typeof CATEGORIES];

export interface Item {
  name: string;
  baseModelURL?: string;
  assetURL?: string;
  thumbnail?: string;
  previewImage?: string;
  modelType?: string;
}

export type LoadWorldFunction = (
  url: string,
  name: string,
  type: string,
  thumbnail: string
) => void;

export interface WorldsDrawerProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  loadScene: (
    name: string,
    url: string,
    type: SIDE_MENU_EVENTS,
    thumbnail: string
  ) => void;
  worlds: Item[];
  selectedWorld: string;
}

export interface CardProps {
  item: Item;
  onLoadWorld: LoadWorldFunction;
  isSelected: boolean;
  isWorld: boolean;
}

export interface CardsProps {
  items: Item[];
  onLoadWorld: LoadWorldFunction;
  selectedWorld: string;
  activeCategory: CategoryType;
}

export interface DrawerTitleProps {
  activeCategory: CategoryType;
  onCategoryChange: (category: CategoryType) => void;
}
